var _excluded = ["title", "className", "children", "onClick", "rel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import config from 'react-global-configuration';
import PropTypes from 'prop-types';
import urlParse from 'url';
var CoreLink = function CoreLink(args) {
  var to = args.to;
  var title = args.title,
    className = args.className,
    children = args.children,
    onClick = args.onClick,
    rel = args.rel,
    props = _objectWithoutProperties(args, _excluded);
  var host = window.location.hostname;
  var API_URL = config.get('API_URL');
  var isInternal = function (url) {
    if (/^internal:/.test(url)) {
      to = to.replace(/^internal:/, '');
      return true;
    }
    return false;
  }(to);
  var isEntity = function (url) {
    if (/^entity:/.test(url)) {
      to = to.replace(/^entity:/, '');
      return true;
    }
    return false;
  }(to);
  var isFile = function (url) {
    if (!url) return false;
    return url.split('/').pop().indexOf('.') > -1;
  }(to);
  var isMailto = function isMailto(url) {
    return /^mailto:/.test(url);
  };
  var isPhoneLink = function isPhoneLink(url) {
    return /^tel:/.test(url);
  };
  if (!to) {
    if (children) {
      return /*#__PURE__*/React.createElement("a", {
        className: className
      }, children);
    }
    return /*#__PURE__*/React.createElement("a", {
      className: className
    }, title);
  }
  function getHostOrPathNameFromUrl(url) {
    var hostname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // Parse the url using the url package. Using whatwg-url gives issues,
    // we consider this safe enough for our use-case.
    var parsed = urlParse.parse(url);
    if (hostname) {
      // If the given url contains a hostname, return it.
      if (parsed.hostname !== null) {
        return parsed.hostname;
      }

      // Otherwise, fall back to the current hostname. This happens for
      // internal links, such as /foobar.
      return window.location.hostname;
    } else {
      return (parsed.pathname || '') + (parsed.search || '') + (parsed.hash || '');
    }
  }
  var linkHost = getHostOrPathNameFromUrl(to);
  var apiHost = getHostOrPathNameFromUrl(API_URL);
  var onClickFunction = function onClickFunction(e) {
    if (onClick) {
      onClick(e);
    }
  };

  // If mailto: or tel:, render a regular a tag and don't scroll the page.
  if (isPhoneLink(to) || isMailto(to)) {
    return /*#__PURE__*/React.createElement("a", _extends({}, props, {
      onClick: onClick,
      target: "_blank",
      rel: rel,
      className: className,
      href: to
    }), children || title);
  }
  if (isFile || (!isInternal || !isEntity) && host !== linkHost && apiHost !== linkHost) {
    // Link is external, or a link to a static file, so create a default anchor.
    return /*#__PURE__*/React.createElement("a", _extends({}, props, {
      onClick: onClickFunction,
      target: "_blank",
      rel: rel,
      className: className,
      href: to
    }), children || title);
  } else {
    // Link is internal, so use a Link to navigate with the History API.
    var pathnameTo = to;

    // Convert links to the same domain to a relative link.
    if (host === linkHost || apiHost === linkHost) {
      pathnameTo = getHostOrPathNameFromUrl(to, false);
    }
    return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
      onClick: onClickFunction,
      className: className,
      to: pathnameTo
    }), children || title);
  }
};
CoreLink.defaultProps = {
  title: '',
  className: '',
  children: null,
  onClick: function onClick() {},
  rel: 'noopener noreferrer'
};
CoreLink.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  rel: PropTypes.string
};
export default CoreLink;